import React from 'react';
import PropTypes from 'prop-types';
import './scss/DrawingToolDragDrop.scss';

class DrawingToolDragDrop extends React.Component {
    constructor(props) {
        super(props);
        this.setActiveOption = this.setActiveOption.bind(this);
    }

    setActiveOption(option) {
        const { update } = this.props;
        update(option);
    }

    render() {
        const { options, t, ariaLabel } = this.props;

        return (
            <>
                <div>{ariaLabel}</div>
                <div className="drawing-tool-options__container">
                    <ol className="drawing-tool-options__items">
                        {options.map(option => (
                            <li className="drawing-tool-options__list" key={option.value}>
                                <button
                                    type="button"
                                    aria-label={ariaLabel}
                                    className="drawing-tool-options__buttons"
                                    onClick={() => {
                                        this.setActiveOption(option);
                                    }}
                                    style={
                                        option.useIcon ? { backgroundColor: '#fff' } : { backgroundColor: option.value }
                                    }
                                >
                                    {option.useIcon ? (
                                        <span>
                                            {option.scale ? (
                                                <img
                                                    src={option.icon}
                                                    alt={t(option.translationKey, option.defaultText)}
                                                />
                                            ) : (
                                                <img
                                                    src={option.icon}
                                                    alt={t(option.translationKey, option.defaultText)}
                                                />
                                            )}
                                        </span>
                                    ) : (
                                        <span className="drawing-tool-options__option-text">{option.value}</span>
                                    )}
                                </button>
                            </li>
                        ))}
                    </ol>
                </div>
            </>
        );
    }
}

DrawingToolDragDrop.defaultProps = {
    ariaLabel: '',
};

const option = PropTypes.shape({
    defaultText: PropTypes.string.isRequired,
    translationKey: PropTypes.string.isRequired,
    icon: PropTypes.string.isRequired,
    scale: PropTypes.number,
    useIcon: PropTypes.bool.isRequired,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
});

DrawingToolDragDrop.propTypes = {
    ariaLabel: PropTypes.string,
    options: PropTypes.arrayOf(option.isRequired).isRequired,
    t: PropTypes.func.isRequired,
    update: PropTypes.func.isRequired,
};

export default DrawingToolDragDrop;
